import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationRoutingModule } from './notification-routing.module';
import { GroupsComponent } from './components/groups/groups.component';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CreateGroupComponent } from './components/create-group/create-group.component';
import { EmailTemplatesComponent } from './components/email-templates/email-templates.component';
import { CreateTemplateComponent } from './components/create-template/create-template.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { EventsComponent, SafeHtmlPipe } from './components/events/events.component';
import { CreateEventComponent } from './components/create-event/create-event.component';
import { MessagesLogComponent } from './components/messages-log/messages-log.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ContactsGroupsComponent } from './components/contacts-groups/contacts-groups.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { CreateContactGroupComponent } from './components/create-contact-group/create-contact-group.component';
@NgModule({
  declarations: [GroupsComponent, CreateGroupComponent, EmailTemplatesComponent, CreateTemplateComponent, EventsComponent, CreateEventComponent,MessagesLogComponent,SafeHtmlPipe, ContactsGroupsComponent, ContactsComponent, CreateContactComponent, CreateContactGroupComponent],
  imports: [
    CommonModule,
    NotificationRoutingModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule,
    SharedModule,
    MatPaginatorModule,
    MatTabsModule,
    MatRadioModule,
    MatTooltipModule,
    MatCardModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatSlideToggleModule,
    AngularEditorModule,
    CKEditorModule
  ]
})
export class NotificationModule { }
